import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const WeldTagStyled = styled(Box).attrs({
  justifyContent: { sm: 'space-between' },
  alignItems: { sm: 'center' },
  pl: { sm: '500' },
  pr: { sm: '550' },
  py: { sm: '600' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey['300']};
  `}
`;

export const WeldMilestonesContainerStyled = styled(Box).attrs({
  pl: { sm: '550' },
  pr: { sm: '450' },
  py: { sm: '450' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey['300']};
  `}
`;
export const SentBackReasonContainerStyled = styled(Box).attrs({
  mt: { sm: '400' },
  pt: { sm: '450' },
  pb: { sm: '500' },
  px: { sm: '450' },
  mr: { sm: '400' },
  flexDirection: { sm: 'column' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey['100']};
    border-radius: ${theme.spacings['200']};
  `}
`;
